import { useEffect, useState } from 'react';

import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { solrApis } from '../../../apis/solrApis';
import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import Loading from '../../../components/elements/loading/Loading';
import Title from '../../../components/elements/title/Title';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import List from '../../../components/sections/list/List';
import { mapSolrStatusToInstance } from '../../../utils/utils';

const ProjectInstanceListPage = () => {
  const { projectId } = useParams();
  const { t } = useTranslation();

  const [instanceList, setInstanceList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: instancesRes } = await solrApis.getInstances(projectId);

      const instancesWithSolrRes = await Promise.all(
        instancesRes.content.map(async (instance) => {
          try {
            const { data: solrStatus } = await solrApis.getSolrStatus(
              projectId,
              instance.id
            );
            const solrWithStatus = mapSolrStatusToInstance(
              instance,
              solrStatus
            );
            return solrWithStatus;
          } catch (error) {
            return { ...instance, solrRunning: [] };
          }
        })
      );

      setInstanceList(instancesWithSolrRes);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container>
      {loading ? (
        <Loading />
      ) : error ? (
        <AlertMessage
          severity="error"
          message={t('fetchInstanceError', { ns: 'notifications' })}
        />
      ) : (
        <section>
          <Breadcrumbs />
          <Title text={t('instances', { ns: 'instance' })} />
          <List isInstanceList data={instanceList} />
        </section>
      )}
    </Container>
  );
};

export default ProjectInstanceListPage;
